import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { TextComponent } from 'design/text/textComponents';
import { FloatingLabelComponent } from 'design/floatingLabel';
import { TextInputControlComponent } from 'design/textInputControl';
import {
  PartnerBindingFormValues,
  PartnerBindingFormViolation,
} from 'types/partnerBindingFormTypes';
import { INPUT_PARTNER_CODE_MAX_LENGTH } from 'utils/constants';

type Props = {
  disabled?: boolean;
  values: PartnerBindingFormValues;
  violations: PartnerBindingFormViolation[];
  onPartnerCodeChange(nextValue: string): void;
};

export const PartnerBindingFieldset = (props: Props) => {
  const { disabled, values, violations, onPartnerCodeChange } = props;

  const intl = useIntlDictionary();

  const partnerCodeHint = React.useMemo(() => {
    for (let violation of violations) {
      switch (violation.name) {
        case 'PartnerCodeIsMissing':
          return intl.inputValidationRequired;
        case 'PartnerCodeIsTooShort':
          return intl.inputValidationPartnerCodeIsTooShort;
        case 'BindingIsNotPossible':
          return intl.inputValidationClientBindingIsNotPossible;
      }
    }
  }, [
    intl.inputValidationPartnerCodeIsTooShort,
    intl.inputValidationRequired,
    intl.inputValidationClientBindingIsNotPossible,
    violations,
  ]);

  return (
    <FloatingLabelComponent
      lifted={!!values.partnerCode}
      invalid={violations.length > 0}
      titleText={
        <TextComponent color="secondary" size="m">
          {intl.partnerCodeInputPlaceholder}
        </TextComponent>
      }
      hintText={
        <TextComponent color="critical" size="s">
          {partnerCodeHint}
        </TextComponent>
      }
    >
      <TextInputControlComponent
        name="partnerCode"
        autoFocus
        value={values.partnerCode}
        disabled={disabled}
        invalid={violations.length > 0}
        maxLength={INPUT_PARTNER_CODE_MAX_LENGTH}
        onValueChange={onPartnerCodeChange}
      />
    </FloatingLabelComponent>
  );
};
